import React from 'react'

import { Text } from 'Components/UI'

import { CheckCircleSvg } from 'Assets/Svg'

import { WHY_CHOOSE_EMAJIN_GOLF_ITEMS } from './constants'
import { Card, Content } from './styles'

function WhyChooseEmajinGolfGallery() {
  return (
    <Content flexDirection={['column', 'column', 'column', 'row']}>
      {WHY_CHOOSE_EMAJIN_GOLF_ITEMS.map(item => (
        <Card key={item.id}>
          {CheckCircleSvg()}

          <Text accent as="h5" bold center screen36>
            {item.title}
          </Text>

          <Text accent center regular screen18>
            {item.caption}
          </Text>
        </Card>
      ))}
    </Content>
  )
}

export default WhyChooseEmajinGolfGallery
